import { AxiosRequestConfig } from "axios";
import axios from "./axios";

export const Tochi = {
  getAssets: (version: string, config: AxiosRequestConfig) =>
    axios.get(`/tochi/files/assets?version=${version}`, config),
  getAnims: (version: string, config: AxiosRequestConfig) =>
    axios.get(`/tochi/files/animations?version=${version}`, config),
  getChickenById: (id: string, version: string, config: AxiosRequestConfig) =>
    axios.get(`/tochi/chickens/${id}?version=${version}`, config),
  getUser: (config: AxiosRequestConfig) => axios.get(`/users/me`, config),
};
